import { useQuery } from 'react-query';
import { scenarioClient } from '../../util/scenarioClient';
import { ScenarioEntity } from '../../types/scenario';

export const useScenariosList = () => {
  return useQuery<ScenarioEntity[]>(
    'scenarios',
    async () => {
      const response = await scenarioClient.get('/scenario');
      return response.data;
    },
    {
      retry: false,
    },
  );
};
